module.exports = __webpack_public_path__ + "img/customerSupportIcon.49cc726f.png";